import api from './api';

// Takvimim — giriş yapan kişinin yıllık takvimi (resmî tatiller + onaylı/bekleyen izinler).
export const getMyCalendar = (year) => api.get('/v1/my-calendar', { params: { year } });
